export default __webpack_public_path__ + "static/media/screenshot4_sm.b4e42ab6.jpg";